<section>
  <!--User administration Tab Options-->
  <kendo-tabstrip (tabSelect)="onTabSelected($event)">
    <kendo-tabstrip-tab [selected]="true" [title]="'User Administration'">
      <ng-template kendoTabContent>
        <section *ngIf="showUserAdminGrid">
          <kendo-grid [data]="userAdminGridView"
                      [height]="470"
                      [sortable]="true"
                      [navigable]="true"
                      [filterable]="true"
                      [groupable]="false"
                      [reorderable]="true"
                      [resizable]="false"
                      [sort]="userAdminGridstate.sort"
                      (sortChange)="userAdminGridSortChange($event)"
                      [pageable]="{ buttonCount: 5, info: true }"
                      [pageSize]="userAdminGridstate.take"
                      [skip]="userAdminGridstate.skip"
                      [columnMenu]="false"
                      (pageChange)="userAdminPageChange($event)"
                      (dataStateChange)="userAdminDataStateChange($event)"
                      [filter]="userAdminGridstate.filter"
                      [loading]="userAdminGridLoading">

            <kendo-grid-column field="userFirstName" title="{{userAdmin?.label?.userFirstName}}" [columnMenu]="false"
                               [filterable]="true" [editable]="false">
              <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                  <kendo-filter-contains-operator></kendo-filter-contains-operator>
                </kendo-grid-string-filter-cell>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="userLastName" title="{{userAdmin.label.userLastName}}" [columnMenu]="false"
                               [filterable]="true" [editable]="false">
              <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                  <kendo-filter-contains-operator></kendo-filter-contains-operator>
                </kendo-grid-string-filter-cell>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="userName" title="{{userAdmin.label.userName}}" [columnMenu]="false"
                               [filterable]="true" [editable]="false">
              <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                  <kendo-filter-contains-operator></kendo-filter-contains-operator>
                </kendo-grid-string-filter-cell>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="customerName" title="{{userAdmin.label.customerName}}" [columnMenu]="false"
                               [filterable]="true" [editable]="false">
              <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                  <kendo-filter-contains-operator></kendo-filter-contains-operator>
                </kendo-grid-string-filter-cell>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="isActive" title="{{userAdmin.label.isActive}}" [columnMenu]="false"
                               [filterable]="false" [editable]="false">
              <ng-template kendoGridCellTemplate let-dataItem>
                <kendo-switch (click)="gridIsActiveSwitchChange(dataItem)"
                              [(ngModel)]="dataItem.isActive"
                              [onLabel]="'Yes'"
                              [offLabel]="'No'"
                              [disabled]="true">
                </kendo-switch>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-command-column title="Actions" [width]="155" field="">
              <ng-template kendoGridCellTemplate let-dataItem>
                <button kendoButton class="m-2 clearKendoButton btn btn-success btnSizeCls"
                        (click)="onEditUser(dataItem,'userAdmin')">
                  <span class=" k-icon k-i-edit k-i-pencil"></span>
                </button>
                <button class="k-button k-grid-remove-command " (click)="removeConfirmation(dataItem,'Admin')">
                  <span class="k-icon k-i-trash">
                  </span>
                </button>
                <br>
              </ng-template>
            </kendo-grid-command-column>

            <ng-template kendoGridNoRecordsTemplate>
            </ng-template>
            <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
              <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
              <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
              <kendo-pager-info></kendo-pager-info>
              <kendo-pager-next-buttons></kendo-pager-next-buttons>
              <kendo-pager-page-sizes [pageSizes]="[50,75,100]"></kendo-pager-page-sizes>
            </ng-template>
          </kendo-grid>
          <div>
            <div class="col-sm-12 center">
              <button (click)="openUserForm()" [icon]="'plus'" class="m-3 clearKendoButton btn btn-success" kendoButton>
                Add New User
              </button>
            </div>
          </div>
        </section>
        <div *ngIf="showUserForm">
          <!--Basic User Details Panel-->
          <kendo-panelbar #panelbar>
            <kendo-panelbar-item [expanded]="true">
              <ng-template kendoPanelBarItemTitle>
                <span>Basic Details*</span>
                <span class="k-icon k-i-cancel" style="color:red;font-weight:300"
                      *ngIf="!newUserForm.label.isBasicDetailValid && newUserForm.label.isDetailsSubmitted"></span>
                <span class="k-icon k-i-check-circle k-i-checkmark-circle"
                      *ngIf="newUserForm.label.isBasicDetailValid && newUserForm.label.isDetailsSubmitted"
                      style="color:green;font-weight:600"></span>
              </ng-template>
              <ng-template kendoPanelBarContent>
                <form name="newUser">
                  <div class="row top m-10">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-10">
                      <div class="row">
                        <div class="col-sm-6">
                          <input type="hidden" class="kendoInput" name="userId" kendoTextBox [(ngModel)]="newUser.userId" />
                          <!--UserLanguageDropDown(Pending)-->
                          <div class="form-group">
                            <label class="lbl">{{newUserForm?.label?.userLanguage}}</label>
                            <kendo-dropdownlist class="kendoInput" name="userLanguage"
                                                [(ngModel)]="newUser.userLanguage"
                                                [data]="getAllLanguages"
                                                [textField]="'userLanguage'"
                                                [valueField]="'userLanguage'"
                                                [valuePrimitive]="true">
                            </kendo-dropdownlist>
                          </div>
                        </div>
                        <div class="col-sm-6">
                          <div class="form-group">
                            <label class="lbl">{{newUserForm?.label?.adminNote}}</label>
                            <textarea kendoTextArea class="kendoInput textArea" name="adminNote" [(ngModel)]="newUser.adminNote" maxlength="500"></textarea>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-6">
                          <h6>Personal Details</h6>
                          <!--userName-->
                          <div class="form-group">
                            <label class="lbl">{{newUserForm?.label?.userName}}<span class="requiredField">*</span></label>
                            <input type="text" class="kendoInput" kendoTextBox name="userName" [(ngModel)]="newUser.userName" [ngClass]="{'borderRed':newUserForm.label.isEmptyUserName ||newUserForm.label.showUserNameIcon}" (blur)="checkUserNameExist()" />
                            <span title="Username is not available" *ngIf="newUserForm?.label.showUserNameIcon" kendoTooltip
                                  class="k-icon k-i-information k-i-info spanInfoIconCls"></span>
                            <span class="k-icon k-i-loading" *ngIf="newUserForm?.label.userNameProcessing"></span>
                            <span class="k-icon k-i-check-circle k-i-checkmark-circle spanInfoIconCls"
                                  *ngIf="newUserForm?.label.isUserNameValid"
                                  style="color:green;font-weight:600"></span>
                          </div>
                          <!--UserFirstName-->
                          <div class="form-group">
                            <label class="lbl">{{newUserForm?.label?.userFirstName}}<span class="requiredField">*</span></label>
                            <input type="text" class="kendoInput" kendoTextBox name="userFirstName" [(ngModel)]="newUser.userFirstName" [ngClass]="{'borderRed':newUserForm.label.isEmptyFirstName && newUserForm.label.isDetailsSubmitted}" (blur)="validateNewUserDetailsForm()" />
                          </div>
                          <!--UserLastName-->
                          <div class="form-group">
                            <label class="lbl">{{newUserForm?.label?.userLastName}}<span class="requiredField">*</span></label>
                            <input type="text" class="kendoInput" kendoTextBox name="userLastName" [(ngModel)]="newUser.userLastName" [ngClass]="{'borderRed':newUserForm.label.isEmptyLastName && newUserForm.label.isDetailsSubmitted}" (blur)="validateNewUserDetailsForm()" />
                          </div>

                          <h6>Customer Account Details<span class="requiredField">*</span></h6>
                          <!--CustomerName-->
                          <div class="form-group">

                            <!--<label class="lbl">{{newUserForm?.label?.customerName}}</label> <br />-->
                            <kendo-dropdownlist class="kendoInput" name="roles"
                                                [(ngModel)]="newUser.defaultCustomer"
                                                [data]="getDefaultCustomer"
                                                [textField]="'customerNameToDisplay'"
                                                [filterable]="true"
                                                [valueField]="'customerNumber'"
                                                (selectionChange)="customerSelect($event)"
                                                (close)="onCloseDefaultCustomerFilter($event)"
                                                (filterChange)="handleDefaultCustomerFilter($event)" [ngClass]="{'borderRed':newUserForm.label.isEmptyDefaultCustomer && newUserForm.label.isDetailsSubmitted}">
                            </kendo-dropdownlist>
                            <!--&nbsp;
    <button class="btn btn-success btn-size" kendoButton (click)="addDefaultCustomer()">
      Add Customer
    </button>-->
                          </div>
                          <div class="form-group div-user-payment-terms">
                            <div class="div-selected-user-customer">
                              <label class="lbl">Selected Default Customer: <strong>{{selectedCustomerNumber}}-{{selectedCustomerName}}</strong></label>
                            </div>
                            <div>
                              <label class="lbl">Terms: <strong>{{selectedPaymentTerms}}</strong></label>
                            </div>
                          </div>
                          <!--isMSCAccount-->
                          <div class="form-group" *ngIf="!newUser.isCSCAccount">
                            <kendo-switch name="isMSCAccount" [(ngModel)]="newUser.isMSCAccount" [onLabel]="'Yes'" [offLabel]="'No'"
                                          (valueChange)="onMSCChange($event)">
                            </kendo-switch>
                            <label class="lbl switch-labels">{{newUserForm?.label?.isMSCAccount}}</label>
                          </div>
                          <!--isCSCAccount-->
                          <div class="form-group" *ngIf="!newUser.isMSCAccount">
                            <kendo-switch name="isCSCAccount" [(ngModel)]="newUser.isCSCAccount" [onLabel]="'Yes'" [offLabel]="'No'">
                            </kendo-switch>
                            <label class="lbl switch-labels">{{newUserForm?.label?.isCSCAccount}}</label>
                          </div>
                          <div class="col-sm-12" *ngIf="!ShowMSCGrid">
                            <kendo-dropdownlist class="txt-size" name="roles"
                                                [(ngModel)]="newUser.mscCustomer"
                                                [data]="getMSCCustomer"
                                                [textField]="'customerNameToDisplay'"
                                                [filterable]="true"
                                                [valueField]="'customerNumber'"
                                                (selectionChange)="mscCustomerSelect($event)"
                                                (close)="onCloseMSCCustomerFilter($event)"
                                                (filterChange)="handleMSCCustomerFilter($event)"
                                                [ngClass]="{'borderRed':newUserForm.label.isEmptyMSCCustomer && newUserForm.label.isDetailsSubmitted}">
                            </kendo-dropdownlist>
                            &nbsp;
                            <button class="btn btn-success btn-size" kendoButton (click)="addCustomer()">
                              Add Customer
                            </button>
                            <div class="form-group" *ngIf="!ShowMSCGrid">
                              <section class="margin-10">
                                <kendo-grid [data]="custDataResult"
                                            [height]="270"
                                            [sortable]="true"
                                            [navigable]="true"
                                            [filterable]="true"
                                            [groupable]="false"
                                            [reorderable]="true"
                                            [resizable]="false"
                                            [sort]="mscCustomerGridstate.sort"
                                            (sortChange)="mscCustomerGridSortChange($event)"
                                            [pageable]="{ buttonCount: 5, info: true }"
                                            [pageSize]="mscCustomerGridstate.take"
                                            [skip]="mscCustomerGridstate.skip"
                                            [columnMenu]="false"
                                            (pageChange)="mscCustomerGridPageChange($event)"
                                            (dataStateChange)="mscCustomerDataStateChange($event)"
                                            [filter]="mscCustomerGridstate.filter">
                                  <kendo-grid-column field="customerNumber" title="Customer Number"></kendo-grid-column>
                                  <kendo-grid-column field="customerName" title="Customer Name"></kendo-grid-column>
                                  <kendo-grid-column field="paymentTerms" [width]="60" title="Terms"></kendo-grid-column>
                                  <kendo-grid-command-column [width]="80"
                                                             [headerStyle]="{'background-color': '#d3d3d3', 'border-color': 'rgba(0,0,0,0)'}"
                                                             [footerStyle]="{'border-color': 'rgba(0,0,0,0)'}">
                                    <ng-template kendoGridCellTemplate class="d-super-center" let-dataItem let-rowIndex="rowIndex">
                                      <button class="k-button k-grid-remove-command " (click)="deleteSelectedCustomers(dataItem.customerNumber)">
                                        <span class="k-icon k-i-trash">
                                        </span>
                                      </button>
                                    </ng-template>
                                  </kendo-grid-command-column>
                                  <ng-template kendoGridNoRecordsTemplate>
                                  </ng-template>
                                  <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
                                    <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                                    <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
                                    <kendo-pager-info></kendo-pager-info>
                                    <kendo-pager-next-buttons></kendo-pager-next-buttons>
                                    <kendo-pager-page-sizes [pageSizes]="[50,75,100]"></kendo-pager-page-sizes>
                                  </ng-template>
                                </kendo-grid>
                              </section>
                            </div>
                          </div>
                          <!--region-->
                          <div class="form-group" *ngIf="isDefaultUserRegion">
                            <label class="lbl">{{newUserForm?.label?.userRegion}}<span class="requiredField">*</span></label>
                            <kendo-dropdownlist class="kendoInput" name="userRegion"
                                                [(ngModel)]="newUser.userRegion"
                                                [data]="getUserRegion"
                                                [textField]="'regionDescription'"
                                                [valueField]="'regionCode'"
                                                [valuePrimitive]="true"
                                                [ngClass]="{'borderRed':newUserForm.label.isEmptyRegion && newUserForm.label.isDetailsSubmitted}" (blur)="validateNewUserDetailsForm()">
                            </kendo-dropdownlist>
                          </div>
                        </div>
                        <div class="col-sm-6">
                          <h6>Contact Details</h6>
                          <div class="form-group">
                            <label class="lbl">{{newUserForm?.label?.phoneNumber}}</label>
                            <kendo-numerictextbox class="kendoInput" [decimals]="0"
                                                  [format]="'#'" [spinners]="false" kendoTextBox name="phoneNumber"
                                                  [(ngModel)]="newUser.phoneNumber"
                                                  [ngClass]="{'borderRed':newUserForm.label.isInvalidPhoneNumber && newUserForm.label.isDetailsSubmitted}"
                                                  (blur)="validateNewUserDetailsForm()"></kendo-numerictextbox>
                            <span title="Phone number length should be minimum 10"
                                  *ngIf="newUserForm.label.isInvalidPhoneNumberMessage" kendoTooltip
                                  class="k-icon k-i-information k-i-info spanInfoIconCls"></span>
                          </div>
                          <div class="form-group">
                            <label class="lbl">{{newUserForm?.label?.email}}<span class="requiredField">*</span></label>
                            <input type="text" class="kendoInput" kendoTextBox name="email" [(ngModel)]="newUser.email" (blur)="emailLeave();validateNewUserDetailsForm()" [ngClass]="{'borderRed':newUserForm.label.isEmailFormatInValid && newUserForm.label.isDetailsSubmitted}" />
                            <span title="Email address is invalid" *ngIf="newUserForm.label.isEmailFormatInValid" kendoTooltip
                                  class="k-icon k-i-information k-i-info spanInfoIconCls"></span>
                          </div>
                          <div class="form-group">
                            <label class="lbl">
                              <b>Customer Requested Setup:</b>
                            </label>
                          </div>
                          <div class="form-group">
                            <label>By Selecting either of the options,you will be required to submit approval from the company Manager/Owner </label>

                            <div class="kendo-input">
                              <label class="lbl switch-labels">Does this account require visibility of account summary?</label>
                              <kendo-switch name="isActive" [(ngModel)]="newUser.requireAccountSummary" [onLabel]="'Yes'" [offLabel]="'No'">
                              </kendo-switch>

                            </div>
                            <!--<div class="kendo-input">
                              <label class="lbl switch-labels">Does this account require visibility of Invoice Details?</label>
                              <kendo-switch name="isActive" [(ngModel)]="newUser.requireInvoiceDetails" [onLabel]="'Yes'" [offLabel]="'No'">
                              </kendo-switch>
                            </div>-->
                          </div>
                          <div class="form-group">
                            <label class="lbl">User Entered Customer Name - {{newUser.userEnteredCustomerName}} </label>
                          </div>
                          <div class="form-group">
                            <label class="lbl">User Entered Customer Number - {{newUser.userEnteredCustomerNumber}} </label>
                          </div>
                          <br>
                          <div class="form-group">
                            <label class="lbl">Street1 Address</label>
                            <input class="kendoInput" kendoTextBox [(ngModel)]="newUser.billingStreet1Address" name="billingStreet1Address" />
                          </div>
                          <div class="form-group">
                            <label class="lbl">Street2 Address</label>
                            <input class="kendoInput" [(ngModel)]="newUser.billingStreet2Address" name="billingStreet2Address" />
                          </div>
                          <div class="form-group">
                            <label class="lbl">Billing City</label>
                            <input class="kendoInput" [(ngModel)]="newUser.billingCity" name="billingCity" />
                          </div>
                          <div class="form-group">
                            <label class="lblCls">Billing State</label>
                            <input class="kendoInput" [(ngModel)]="newUser.billingState" name="billingState" />
                          </div>
                          <div class="form-group">
                            <label class="lbl">County</label>
                            <input class="kendoInput" [(ngModel)]="newUser.billingCounty" name="billingCounty" />
                          </div>
                          <div class="form-group">
                            <label class="lbl">Country</label>
                            <input class="kendoInput" [(ngModel)]="newUser.billingCountry" name="billingCountry" />
                          </div>
                          <div class="form-group">
                            <label class="lbl">ZipCode</label>
                            <input class="kendoInput" [(ngModel)]="newUser.billingZipCode" name="billingZipCode" />
                          </div>
                          <div class="form-group">
                            <label class="lbl">Phone Number</label>
                            <kendo-numerictextbox class="kendoInput" [(ngModel)]="newUser.billingPhoneNumber" name="billingPhoneNumber" [decimals]="0"
                                                  [format]="'#'" [spinners]="false" maxlength="10"></kendo-numerictextbox>

                          </div>
                        </div>
                      </div>
                      <br />
                      <div class="row">

                        <div class="col-sm-6"></div>
                      </div>

                    </div>
                    <div class="col-sm-1"></div>
                  </div>
                </form>
                <div class="row">
                  <div class="col-12 center">
                    <button kendoButton primary="true" class="m-3" (click)="continueNextPanel('basic details')">
                      Continue
                    </button>
                  </div>
                </div>
              </ng-template>
            </kendo-panelbar-item>
            <kendo-panelbar-item>
              <ng-template kendoPanelBarItemTitle>
                <span>User Roles*</span>
                <span class="k-icon k-i-cancel" style="color:red;font-weight:300"
                      *ngIf="!newUserForm.label.isUserRolesValid && newUserForm.label.isRolesSubmitted"></span>
                <span class="k-icon k-i-check-circle k-i-checkmark-circle"
                      *ngIf="newUserForm.label.isUserRolesValid && newUserForm.label.isRolesSubmitted"
                      style="color:green;font-weight:600"></span>                
              </ng-template>
              <ng-template kendoPanelBarContent>
                <!--RoleGrid-->
                <div class="row">
                  <div class="col-sm-12 m-10 m-top m-bot">
                    <span *ngIf="isCCRoleCustomer" class="ccCustomerRoleCls">{{isCCRoleCustomerText}}</span>
                    <kendo-splitter orientation="vertical" style="height: 340px;">

                      <kendo-splitter-pane>
                        <kendo-splitter>

                          <kendo-splitter-pane [collapsible]="true" size="50%">
                            <div class="pane-content">
                              <section class="margin-10">
                                <kendo-grid [data]="allRolesGridView"
                                            [navigable]="true"
                                            [filterable]="true"
                                            [groupable]="false"
                                            [reorderable]="true"
                                            [resizable]="false"
                                            [sort]="allRolesGridstate.sort"
                                            (sortChange)="allRolesGridSortChange($event)"
                                            [pageable]="{ buttonCount: 5, info: true }"
                                            [pageSize]="allRolesGridstate.take"
                                            [skip]="allRolesGridstate.skip"
                                            [columnMenu]="false"
                                            (pageChange)="allRolesGridPageChange($event)"
                                            (dataStateChange)="allRolesDataStateChange($event)"
                                            [filter]="allRolesGridstate.filter">
                                  <kendo-grid-column field="rolesCode" title="All Roles"></kendo-grid-column>
                                  <kendo-grid-command-column [width]="80"
                                                             [headerStyle]="{'background-color': '#d3d3d3', 'border-color': 'rgba(0,0,0,0)'}"
                                                             [footerStyle]="{'border-color': 'rgba(0,0,0,0)'}">
                                    <ng-template kendoGridCellTemplate class="d-super-center" let-dataItem let-rowIndex="rowIndex">
                                      <button class="k-button" (click)="addRoles(dataItem)">
                                        <span class="k-icon k-i-plus">
                                        </span>
                                      </button>
                                    </ng-template>
                                  </kendo-grid-command-column>
                                  <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
                                    <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                                    <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
                                    <kendo-pager-info></kendo-pager-info>
                                    <kendo-pager-next-buttons></kendo-pager-next-buttons>
                                    <kendo-pager-page-sizes [pageSizes]="[50,75,100]"></kendo-pager-page-sizes>
                                  </ng-template>
                                </kendo-grid>
                              </section>
                            </div>
                          </kendo-splitter-pane>

                          <kendo-splitter-pane [collapsible]="true">
                            <div class="pane-content">
                              <section class="margin-10">
                                <kendo-grid [data]="selectedRolesGridView"
                                            [navigable]="true"
                                            [filterable]="true"
                                            [groupable]="false"
                                            [reorderable]="true"
                                            [resizable]="false"
                                            [sort]="selectedRolesGridstate.sort"
                                            (sortChange)="selectedRolesGridSortChange($event)"
                                            [pageable]="{ buttonCount: 5, info: true }"
                                            [pageSize]="selectedRolesGridstate.take"
                                            [skip]="selectedRolesGridstate.skip"
                                            [columnMenu]="false"
                                            (pageChange)="selectedRolesGridPageChange($event)"
                                            (dataStateChange)="selectedRolesDataStateChange($event)"
                                            [filter]="selectedRolesGridstate.filter">
                                  <kendo-grid-column field="rolesCode" title="Selected Roles"></kendo-grid-column>
                                  <kendo-grid-command-column [width]="80"
                                                             [headerStyle]="{'background-color': '#d3d3d3', 'border-color': 'rgba(0,0,0,0)'}"
                                                             [footerStyle]="{'border-color': 'rgba(0,0,0,0)'}">
                                    <ng-template kendoGridCellTemplate class="d-super-center" let-dataItem let-rowIndex="rowIndex">
                                      <button class="k-button k-grid-remove-command " (click)="deleteSelectedRoles(rowIndex)">
                                        <span class="k-icon k-i-trash">
                                        </span>
                                      </button>
                                    </ng-template>
                                  </kendo-grid-command-column>
                                  <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
                                    <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                                    <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
                                    <kendo-pager-info></kendo-pager-info>
                                    <kendo-pager-next-buttons></kendo-pager-next-buttons>
                                    <kendo-pager-page-sizes [pageSizes]="[50,75,100]"></kendo-pager-page-sizes>
                                  </ng-template>
                                </kendo-grid>
                              </section>
                            </div>
                          </kendo-splitter-pane>

                        </kendo-splitter>
                      </kendo-splitter-pane>
                    </kendo-splitter>

                  </div>
                </div>

                <div class="row">
                  <div class="col-12 center">
                    <button kendoButton primary="true" class="m-3" (click)="continueNextPanel('roles')">
                      Continue
                    </button>
                  </div>
                </div>
              </ng-template>
            </kendo-panelbar-item>
            <kendo-panelbar-item [expanded]="false">
              <ng-template kendoPanelBarItemTitle>
                <span>Account Activity</span>
                <span class="k-icon k-i-cancel" style="color:red;font-weight:300"
                      *ngIf="!newUserForm.label.isAccountActivityValid && newUserForm.label.isSubmitted"></span>
                <span class="k-icon k-i-check-circle k-i-checkmark-circle"
                      *ngIf="newUserForm.label.isAccountActivityValid && newUserForm.label.isSubmitted"
                      style="color:green;font-weight:600"></span>
              </ng-template>
              <ng-template kendoPanelBarContent>
                <div class="row margin-10">
                  <div class="col-sm-1"></div>
                  <div class="col-sm-10">
                    <div class="row">
                      <div class="col-sm-6">
                        <h6>Actions</h6>
                        <!--isActive-->
                        <div class="form-group">
                          <kendo-switch name="isActive" [(ngModel)]="newUser.isActive" [onLabel]="'Yes'" [offLabel]="'No'">
                          </kendo-switch>
                          <label class="lbl switch-labels">{{newUserForm?.label?.isActive}}</label>
                        </div>
                        <div class="form-group">
                          <kendo-switch name="forcePasswordReset" [(ngModel)]="newUser.forcePasswordReset" [onLabel]="'Yes'" [offLabel]="'No'">
                          </kendo-switch>
                          <label class="lbl switch-labels">{{newUserForm?.label?.forcePasswordReset}}</label>
                        </div>
                        <div class="form-group">
                          <kendo-switch name="forceTermsAndCondition " [(ngModel)]="newUser.forceTermsAndCondition  " [onLabel]="'Yes'" [offLabel]="'No'">
                          </kendo-switch>
                          <label class="lbl switch-labels">{{newUserForm?.label?.forceTermsAndCondition }}</label>
                        </div>
                        <div class="form-group">
                          <kendo-switch name="canPlaceOrder" [(ngModel)]="newUser.canPlaceOrder" [onLabel]="'Yes'" [offLabel]="'No'">
                          </kendo-switch>
                          <label class="lbl switch-labels">{{newUserForm?.label?.canPlaceOrder}}</label>
                        </div>
                        <div class="form-group">
                          <kendo-switch name="sendTempPW" [(ngModel)]="newUser.sendTempPW"  [onLabel]="'Yes'" [offLabel]="'No'">
                          </kendo-switch>
                          <label class="lbl switch-labels">{{newUserForm?.label?.sendTempPW}}</label>
                        </div>


                        <!--lastTermsAndConditionAccepted  (Pending)-->
                        <!--<div class="form-group">
      <kendo-switch name="lastTermsAndConditionAccepted " [(ngModel)]="newUser.lastTermsAndConditionAccepted" [onLabel]="'Yes'" [offLabel]="'No'">
      </kendo-switch>
      <label class="lbl switch-labels">{{newUserForm?.label?.lastTermsAndConditionAccepted  }}</label>
    </div>
    <div class="form-group">
      <kendo-switch name="lockCount " [(ngModel)]="newUser.lockCount" [onLabel]="'Yes'" [offLabel]="'No'">
      </kendo-switch>
      <label class="lbl switch-labels">{{newUserForm?.label?.lockCount  }}</label>
    </div>-->
                        <!--<div class="form-group">
      <label class="lbl">{{newUserForm?.label?.effectiveFrom }}</label>
      <kendo-datepicker class="kendoInput" [(ngModel)]="newUser.effectiveFrom"
                        placeholder="MM/DD/YYYY"
                        format="MM/dd/yyyy" [min]="newUserForm.label.todayDate"
                        [formatPlaceholder]="{year: 'YYYY', month: 'MM', day: 'DD'}">
      </kendo-datepicker>
    </div>
    <div class="form-group">
      <label class="lbl">{{newUserForm?.label?.effectiveTo }}</label>
      <kendo-datepicker class="kendoInput" [(ngModel)]="newUser.effectiveTo"
                        placeholder="MM/DD/YYYY"
                        format="MM/dd/yyyy" [min]="newUserForm.label.todayDate"
                        [formatPlaceholder]="{year: 'YYYY', month: 'MM', day: 'DD'}">
      </kendo-datepicker>
    </div>-->

                      </div>
                      <div class="col-sm-6">
                        <div><b>Last Login Date/TimeStamp: </b><p>{{newUser.lastLogin}}</p></div>
                      </div>
                      <!--<div class="col-sm-6">
    <h6>Services</h6>-->
                      <!--hasInvoiceInquiry(Pending)-->
                      <!--<div class="form-group">
    <kendo-switch name="hasInvoiceInquiry" [(ngModel)]="newUser.hasInvoiceInquiry" [onLabel]="'Yes'" [offLabel]="'No'">
    </kendo-switch>
    <label class="lbl switch-labels">{{newUserForm?.label?.hasInvoiceInquiry}}</label>
  </div>-->
                      <!--hasAccountSummary(Pending)-->
                      <!--<div class="form-group">
    <kendo-switch name="hasAccountSummary" [(ngModel)]="newUser.hasAccountSummary" [onLabel]="'Yes'" [offLabel]="'No'">
    </kendo-switch>
    <label class="lbl switch-labels">{{newUserForm?.label?.hasAccountSummary}}</label>
  </div>-->
                      <!--hasManageAddress(Pending)-->
                      <!--<div class="form-group">
    <kendo-switch name="hasManageAddress" [(ngModel)]="newUser.hasManageAddress" [onLabel]="'Yes'" [offLabel]="'No'">
    </kendo-switch>
    <label class="lbl switch-labels">{{newUserForm?.label?.hasManageAddress}}</label>
  </div>-->
                      <!--canPlaceOrder(Pending)-->
                      <!--<div class="form-group">
      <kendo-switch name="canPlaceOrder" [(ngModel)]="newUser.canPlaceOrder" [onLabel]="'Yes'" [offLabel]="'No'">
      </kendo-switch>
      <label class="lbl switch-labels">{{newUserForm?.label?.canPlaceOrder}}</label>
    </div>

  </div>-->
                    </div>
                    <div class="col-sm-1"></div>
                  </div>
                </div>

              </ng-template>
            </kendo-panelbar-item>

          </kendo-panelbar>
          <div class="row" style="text-align:center">
            <div class="col-sm-12">
              <div class="btn-group" role="group">
                <button kendoButton [disabled]="newUserForm.saveInProcess" class=" m-3 btn k-button dialogBtnSize"
                        (click)="closeUserForm()">
                  Close
                </button> &nbsp;&nbsp;
                <button kendoButton [disabled]="newUserForm.saveInProcess" class=" m-3 btn btn-success dialogBtnSize"
                        (click)="insertUserData('approve','userAdmin')">
                  Save <kendo-loader *ngIf="newUserForm.saveInProcess" style="color:blue"></kendo-loader>
                </button>

              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab [title]="workListTitle">
      <!--<ng-template kendoTabTitle>
      </ng-template>-->
      <ng-template kendoTabContent>
        <section *ngIf="showWorkListGrid">
          <kendo-grid [data]="worklistGridView"
                      [height]="470"
                      [sortable]="true"
                      [navigable]="true"
                      [filterable]="true"
                      [groupable]="false"
                      [reorderable]="true"
                      [resizable]="false"
                      [sort]="worklistGridstate.sort"
                      (sortChange)="worklistGridSortChange($event)"
                      [pageable]="{ buttonCount: 5, info: true }"
                      [pageSize]="worklistGridstate.take"
                      [skip]="worklistGridstate.skip"
                      [columnMenu]="false"
                      (pageChange)="worklistGridPageChange($event)"
                      (dataStateChange)="worklistGridDataStateChange($event)"
                      [filter]="worklistGridstate.filter"
                      [loading]="worklistGridLoading">

            <kendo-grid-column field="userFirstName" title="{{userAdmin.label.userFirstName}}" [columnMenu]="false"
                               [filterable]="true" [editable]="false">
              <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                  <kendo-filter-contains-operator></kendo-filter-contains-operator>
                </kendo-grid-string-filter-cell>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="userLastName" title="{{userAdmin.label.userLastName}}" [columnMenu]="false"
                               [filterable]="true" [editable]="false">
              <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                  <kendo-filter-contains-operator></kendo-filter-contains-operator>
                </kendo-grid-string-filter-cell>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="userName" title="{{userAdmin.label.userName}}" [columnMenu]="false"
                               [filterable]="true" [editable]="false">
              <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                  <kendo-filter-contains-operator></kendo-filter-contains-operator>
                </kendo-grid-string-filter-cell>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="customerName" title="{{userAdmin.label.customerName}}" [columnMenu]="false"
                               [filterable]="true" [editable]="false">
              <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                  <kendo-filter-contains-operator></kendo-filter-contains-operator>
                </kendo-grid-string-filter-cell>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="isActive" title="{{userAdmin.label.isActive}}" [columnMenu]="false"
                               [filterable]="false" [editable]="false">
              <ng-template kendoGridCellTemplate let-dataItem>
                <kendo-switch (click)="gridIsActiveSwitchChange(dataItem)" [(ngModel)]="dataItem.isActive" [onLabel]="'Yes'"
                              [offLabel]="'No'" [disabled]="true">
                </kendo-switch>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="dateAdded" title="{{userAdmin.label.dateAdded}}" [columnMenu]="false"
                               [filterable]="true" [editable]="false">
              <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                  <kendo-filter-contains-operator></kendo-filter-contains-operator>
                </kendo-grid-string-filter-cell>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-command-column title="Approve" [width]="155" field="">
              <ng-template kendoGridCellTemplate let-dataItem>
                <button kendoButton class="m-2 clearKendoButton btn btn-success btnSizeCls"
                        (click)="onEditUser(dataItem,'worklist')">
                  <span class=" k-icon k-i-edit k-i-pencil"></span>
                </button>

                <button class="k-button k-grid-remove-command " (click)="removeConfirmation(dataItem,'Worklist');selectedGridRow(dataItem) ">
                  <span class="k-icon k-i-trash">
                  </span>
                </button>
                <br>
              </ng-template>
            </kendo-grid-command-column>

            <ng-template kendoGridNoRecordsTemplate>
            </ng-template>
            <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
              <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
              <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
              <kendo-pager-info></kendo-pager-info>
              <kendo-pager-next-buttons></kendo-pager-next-buttons>
              <kendo-pager-page-sizes [pageSizes]="[50,75,100]"></kendo-pager-page-sizes>
            </ng-template>
          </kendo-grid>
        </section>
        <div *ngIf="showWorkListUserForm">
          <!--Basic User Details Panel-->
          <kendo-panelbar #panelbar>
            <kendo-panelbar-item [expanded]="true">
              <ng-template kendoPanelBarItemTitle>
                <span>Basic Details*</span>
                <span class="k-icon k-i-cancel" style="color:red;font-weight:300"
                      *ngIf="!newUserForm.label.isBasicDetailValid && newUserForm.label.isDetailsSubmitted"></span>
                <span class="k-icon k-i-check-circle k-i-checkmark-circle"
                      *ngIf="newUserForm.label.isBasicDetailValid && newUserForm.label.isDetailsSubmitted"
                      style="color:green;font-weight:600"></span>
              </ng-template>
              <ng-template kendoPanelBarContent>
                <form name="newUser">
                  <div class="row top m-10">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-10">
                      <div class="row">
                        <div class="col-sm-6">
                          <input type="hidden" class="kendoInput" name="userId" kendoTextBox [(ngModel)]="newUser.userId" />
                          <!--UserLanguageDropDown(Pending)-->
                          <div class="form-group">
                            <label class="lbl">{{newUserForm?.label?.userLanguage}}</label>
                            <kendo-dropdownlist class="kendoInput" name="userLanguage"
                                                [(ngModel)]="newUser.userLanguage"
                                                [data]="getAllLanguages"
                                                [textField]="'userLanguage'"
                                                [valueField]="'userLanguage'"
                                                [valuePrimitive]="true">
                            </kendo-dropdownlist>
                          </div>
                        </div>
                        <div class="col-sm-6">
                          <div class="form-group">
                            <label class="lbl">{{newUserForm?.label?.adminNote}}</label>
                            <input type="text" class="kendoInput" kendoTextBox name="adminNote" [(ngModel)]="newUser.adminNote" />
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-6">
                          <h6>Personal Details</h6>
                          <!--userName-->
                          <div class="form-group">
                            <label class="lbl">{{newUserForm?.label?.userName}}<span class="requiredField">*</span></label>
                            <input type="text" class="kendoInput" kendoTextBox name="userName" [(ngModel)]="newUser.userName" [ngClass]="{'borderRed':newUserForm.label.isEmptyUserName ||newUserForm.label.showUserNameIcon}" (blur)="checkUserNameExist()" />
                            <span title="Username is not available" *ngIf="newUserForm?.label.showUserNameIcon" kendoTooltip
                                  class="k-icon k-i-information k-i-info spanInfoIconCls"></span>
                            <span class="k-icon k-i-loading" *ngIf="newUserForm?.label.userNameProcessing"></span>
                            <span class="k-icon k-i-check-circle k-i-checkmark-circle spanInfoIconCls"
                                  *ngIf="newUserForm?.label.isUserNameValid"
                                  style="color:green;font-weight:600"></span>
                          </div>
                          <!--UserFirstName-->
                          <div class="form-group">
                            <label class="lbl">{{newUserForm?.label?.userFirstName}}<span class="requiredField">*</span></label>
                            <input type="text" class="kendoInput" kendoTextBox name="userFirstName" [(ngModel)]="newUser.userFirstName" [ngClass]="{'borderRed':newUserForm.label.isEmptyFirstName && newUserForm.label.isDetailsSubmitted}" (blur)="validateNewUserDetailsForm()" />
                          </div>
                          <!--UserLastName-->
                          <div class="form-group">
                            <label class="lbl">{{newUserForm?.label?.userLastName}}<span class="requiredField">*</span></label>
                            <input type="text" class="kendoInput" kendoTextBox name="userLastName" [(ngModel)]="newUser.userLastName" [ngClass]="{'borderRed':newUserForm.label.isEmptyLastName && newUserForm.label.isDetailsSubmitted}" (blur)="validateNewUserDetailsForm()" />
                          </div>
                          <div class="row">
                            <div class="col-sm-12">
                              <h6>Customer Account Details<span class="requiredField">*</span></h6>
                              <!--CustomerName-->

                              <div class="form-group">

                                <!--<label class="lbl">{{newUserForm?.label?.customerName}}</label> <br />-->
                                <kendo-dropdownlist class="kendoInput" name="roles"
                                                    [(ngModel)]="newUser.defaultCustomer"
                                                    [data]="getDefaultCustomer"
                                                    [textField]="'customerNameToDisplay'"
                                                    [filterable]="true"
                                                    [valueField]="'customerNumber'"
                                                    (selectionChange)="customerSelect($event)"
                                                    (filterChange)="handleDefaultCustomerFilter($event)" [ngClass]="{'borderRed':newUserForm.label.isEmptyDefaultCustomer && newUserForm.label.isDetailsSubmitted}">
                                  >
                                </kendo-dropdownlist>
                                <!--&nbsp;de
        <button class="btn btn-success btn-size" kendoButton (click)="addDefaultCustomer()">
          Add Customer
        </button>-->
                              </div>
                              <div class="form-group">
                                <label class="lbl">Selected Default Customer: <strong>{{fv}}-{{selectedCustomerName}}</strong></label>
                              </div>
                            </div>
                            <!--isMSCAccount-->
                            <div class="form-group" *ngIf="!newUser.isCSCAccount">
                              <kendo-switch name="isMSCAccount" [(ngModel)]="newUser.isMSCAccount" [onLabel]="'Yes'" [offLabel]="'No'"
                                            (valueChange)="onMSCChange($event)">
                              </kendo-switch>
                              <label class="lbl switch-labels">{{newUserForm?.label?.isMSCAccount}}</label>
                            </div><br>
                            <!--isCSCAccount-->
                            <div class="form-group" *ngIf="!newUser.isMSCAccount">
                              <kendo-switch name="isCSCAccount" [(ngModel)]="newUser.isCSCAccount" [onLabel]="'Yes'" [offLabel]="'No'">
                              </kendo-switch>
                              <label class="lbl switch-labels">{{newUserForm?.label?.isCSCAccount}}</label>
                            </div>
                            
                            <div class="m-10 m-top m-bot" *ngIf="!ShowMSCGrid">
                              <kendo-dropdownlist class="txt-size" name="roles"
                                                  [(ngModel)]="newUser.mscCustomer"
                                                  [data]="getMSCCustomer"
                                                  [textField]="'customerNameToDisplay'"
                                                  [filterable]="true"
                                                  [valueField]="'customerNumber'"
                                                  (selectionChange)="mscCustomerSelect($event)"
                                                  (filterChange)="handleMSCCustomerFilter($event)">
                              </kendo-dropdownlist>
                              &nbsp;
                              <button class="btn btn-success btn-size" kendoButton (click)="addCustomer()">
                                Add Customer
                              </button>
                              <div class="row" *ngIf="!ShowMSCGrid">
                                <div class="col-sm-12">
                                  <section class="margin-10">
                                    <kendo-grid [data]="custDataResult"
                                                [height]="270"
                                                [sortable]="true"
                                                [navigable]="true"
                                                [filterable]="true"
                                                [groupable]="false"
                                                [reorderable]="true"
                                                [resizable]="false"
                                                [sort]="mscCustomerGridstate.sort"
                                                (sortChange)="mscCustomerGridSortChange($event)"
                                                [pageable]="{ buttonCount: 5, info: true }"
                                                [pageSize]="mscCustomerGridstate.take"
                                                [skip]="mscCustomerGridstate.skip"
                                                [columnMenu]="false"
                                                (pageChange)="mscCustomerGridPageChange($event)"
                                                (dataStateChange)="mscCustomerDataStateChange($event)"
                                                [filter]="mscCustomerGridstate.filter">
                                      <kendo-grid-column field="customerName" title="Customer Name"></kendo-grid-column>
                                      <kendo-grid-command-column [width]="80"
                                                                 [headerStyle]="{'background-color': '#d3d3d3', 'border-color': 'rgba(0,0,0,0)'}"
                                                                 [footerStyle]="{'border-color': 'rgba(0,0,0,0)'}">
                                        <ng-template kendoGridCellTemplate class="d-super-center" let-dataItem let-rowIndex="rowIndex">
                                          <button class="k-button k-grid-remove-command " (click)="deleteSelectedCustomers(rowIndex)">
                                            <span class="k-icon k-i-trash">
                                            </span>
                                          </button>
                                        </ng-template>
                                      </kendo-grid-command-column>
                                      <ng-template kendoGridNoRecordsTemplate>
                                      </ng-template>
                                      <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
                                        <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                                        <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
                                        <kendo-pager-info></kendo-pager-info>
                                        <kendo-pager-next-buttons></kendo-pager-next-buttons>
                                        <kendo-pager-page-sizes [pageSizes]="[50,75,100]"></kendo-pager-page-sizes>
                                      </ng-template>
                                    </kendo-grid>
                                  </section>
                                </div>
                              </div>
                            </div>
                            
                            <div class="col-sm-6"></div>
                          </div>
                         <!--region-->
                         <div class="form-group" *ngIf="isDefaultUserRegion">
                          <label class="lbl">{{newUserForm?.label?.userRegion}}<span class="requiredField">*</span></label>
                          <kendo-dropdownlist class="kendoInput" name="userRegion"
                                              [(ngModel)]="newUser.userRegion"
                                              [data]="getUserRegion"
                                              [textField]="'regionDescription'"
                                              [valueField]="'regionCode'"
                                              [valuePrimitive]="true"
                                              [ngClass]="{'borderRed':newUserForm.label.isEmptyRegion && newUserForm.label.isDetailsSubmitted}" (blur)="validateNewUserDetailsForm()">
                          </kendo-dropdownlist>
                        </div>
                        </div>
                        <div class="col-sm-6">
                          <h6>Contact Details</h6>
                          <!--Phone Number(Pending)-->
                          <div class="form-group">
                            <label class="lbl">{{newUserForm?.label?.phoneNumber}}</label>
                            <!--<input type="number" class="kendoInput" kendoTextBox name="phoneNumber" [(ngModel)]="newUser.phoneNumber" />-->
                            <kendo-numerictextbox class="kendoInput" [decimals]="0"
                                                  [format]="'#'" [spinners]="false" kendoTextBox name="phoneNumber"
                                                  [(ngModel)]="newUser.phoneNumber"
                                                  [ngClass]="{'borderRed':newUserForm.label.isInvalidPhoneNumber && newUserForm.label.isDetailsSubmitted}"
                                                  (blur)="validateNewUserDetailsForm()"></kendo-numerictextbox>
                            <span title="Phone number length should be minimum 10"
                                  *ngIf="newUserForm.label.isInvalidPhoneNumberMessage" kendoTooltip
                                  class="k-icon k-i-information k-i-info spanInfoIconCls"></span>
                          </div>
                          <!--Email(Pending)-->
                          <div class="form-group">
                            <label class="lbl">{{newUserForm?.label?.email}}<span class="requiredField">*</span></label>
                            <input type="text" class="kendoInput" kendoTextBox name="email" [(ngModel)]="newUser.email" (blur)="emailLeave();validateNewUserDetailsForm()" [ngClass]="{'borderRed':newUserForm.label.isEmailFormatInValid && newUserForm.label.isDetailsSubmitted}" />
                            <span title="Email address is invalid" *ngIf="newUserForm.label.isEmailFormatInValid" kendoTooltip
                                  class="k-icon k-i-information k-i-info spanInfoIconCls"></span>
                          </div>


                          <div class="form-group">
                            <label class="lbl">
                              <b>Customer Requested Setup:</b>
                            </label>
                          </div>
                          <div class="form-group">
                            <label>By Selecting either of the options,you will be required to submit approval from the company Manager/Owner </label>

                            <div class="kendo-input">
                              <label class="lbl switch-labels">Does this account require visibility of account summary?</label>
                              <kendo-switch name="isActive" [(ngModel)]="newUser.requireAccountSummary" [onLabel]="'Yes'" [offLabel]="'No'">
                              </kendo-switch>

                            </div>
                            <!--<div class="kendo-input">
                              <label class="lbl switch-labels">Does this account require visibility of Invoice Details?</label>
                              <kendo-switch name="isActive" [(ngModel)]="newUser.requireInvoiceDetails" [onLabel]="'Yes'" [offLabel]="'No'">
                              </kendo-switch>
                            </div>-->
                          </div>

                          <div class="form-group">
                            <label class="lbl">User Entered Customer Name - {{newUser.userEnteredCustomerName}} </label>
                          </div>
                          <div class="form-group">
                            <label class="lbl">User Entered Customer Number - {{newUser.userEnteredCustomerNumber}} </label>
                          </div>

                          <div class="form-group">
                            <label class="lbl">Street1 Address</label>
                            <input class="kendoInput" kendoTextBox [(ngModel)]="newUser.billingStreet1Address" name="billingStreet1Address" />
                          </div>
                          <div class="form-group">
                            <label class="lbl">
                              Street2 Address
                            </label>
                            <input class="kendoInput" [(ngModel)]="newUser.billingStreet2Address" name="billingStreet2Address"
                                   [ngClass]="{'borderRed':newUserForm.label.isInvalidStreet2Address && newUserForm.label.isDetailsSubmitted}"
                                   (blur)="validateNewUserDetailsForm()" />
                          </div>
                          <div class="form-group">
                            <label class="lbl">Billing City</label>
                            <input class="kendoInput" [(ngModel)]="newUser.billingCity" name="billingCity" />
                          </div>
                          <div class="form-group">
                            <label class="lbl">Billing State</label>
                            <input class="kendoInput" [(ngModel)]="newUser.billingState" name="billingState" />
                          </div>
                          <div class="form-group">
                            <label class="lbl">County</label>
                            <input class="kendoInput" [(ngModel)]="newUser.billingCounty" name="billingCounty" />
                          </div>
                          <div class="form-group">
                            <label class="lbl">Country</label>
                            <input class="kendoInput" [(ngModel)]="newUser.billingCountry" name="billingCountry" />
                          </div>
                          <div class="form-group">
                            <label class="lbl">ZipCode</label>
                            <input class="kendoInput" [(ngModel)]="newUser.billingZipCode" name="billingZipCode" />
                          </div>
                          <div class="form-group">
                            <label class="lbl">Phone Number</label>
                            <kendo-numerictextbox class="kendoInput" [(ngModel)]="newUser.billingPhoneNumber" name="billingPhoneNumber" [decimals]="0"
                                                  [format]="'#'" [spinners]="false"></kendo-numerictextbox>
                            <span title="{{newUserForm.invalidPhoneLbl?newUserTxt.invalidPhoneLbl:newUserForm.invalidPhoneLbl}}"></span>
                          </div>

                        </div>
                      </div>
                      <br />
                    </div>
                    <div class="col-sm-1"></div>
                  </div>
                </form>
                <div class="row">
                  <div class="col-12 center">
                    <button kendoButton primary="true" class="m-3" (click)="continueNextPanel('basic details')">
                      Continue
                    </button>
                  </div>
                </div>
              </ng-template>
            </kendo-panelbar-item>
            <kendo-panelbar-item>
              <ng-template kendoPanelBarItemTitle>
                <span>User Roles*</span>
                <span class="k-icon k-i-cancel" style="color:red;font-weight:300"
                      *ngIf="!newUserForm.label.isUserRolesValid && newUserForm.label.isRolesSubmitted"></span>
                <span class="k-icon k-i-check-circle k-i-checkmark-circle"
                      *ngIf="newUserForm.label.isUserRolesValid && newUserForm.label.isRolesSubmitted"
                      style="color:green;font-weight:600"></span>                
              </ng-template>
              <ng-template kendoPanelBarContent>
                <!--RoleGrid-->
                <div class="row">
                  <div class="col-sm-12 m-10 m-top m-bot">
                    <span *ngIf="isCCRoleCustomer" class="ccCustomerRoleCls">{{isCCRoleCustomerText}}</span>
                    <kendo-splitter orientation="vertical" style="height: 340px;">

                      <kendo-splitter-pane>
                        <kendo-splitter>

                          <kendo-splitter-pane [collapsible]="true" size="50%">
                            <div class="pane-content">
                              <section class="margin-10">
                                <kendo-grid [data]="allRolesGridView"
                                            [navigable]="true"
                                            [filterable]="true"
                                            [groupable]="false"
                                            [reorderable]="true"
                                            [resizable]="false"
                                            [sort]="allRolesGridstate.sort"
                                            (sortChange)="allRolesGridSortChange($event)"
                                            [pageable]="{ buttonCount: 5, info: true }"
                                            [pageSize]="allRolesGridstate.take"
                                            [skip]="allRolesGridstate.skip"
                                            [columnMenu]="false"
                                            (pageChange)="allRolesGridPageChange($event)"
                                            (dataStateChange)="allRolesDataStateChange($event)"
                                            [filter]="allRolesGridstate.filter">
                                  <kendo-grid-column field="rolesCode" title="All Roles"></kendo-grid-column>
                                  <kendo-grid-command-column [width]="80"
                                                             [headerStyle]="{'background-color': '#d3d3d3', 'border-color': 'rgba(0,0,0,0)'}"
                                                             [footerStyle]="{'border-color': 'rgba(0,0,0,0)'}">
                                    <ng-template kendoGridCellTemplate class="d-super-center" let-dataItem let-rowIndex="rowIndex">
                                      <button class="k-button" (click)="addRoles(dataItem)">
                                        <span class="k-icon k-i-plus">
                                        </span>
                                      </button>
                                    </ng-template>
                                  </kendo-grid-command-column>
                                  <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
                                    <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                                    <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
                                    <kendo-pager-info></kendo-pager-info>
                                    <kendo-pager-next-buttons></kendo-pager-next-buttons>
                                    <kendo-pager-page-sizes [pageSizes]="[50,75,100]"></kendo-pager-page-sizes>
                                  </ng-template>
                                </kendo-grid>
                              </section>
                            </div>
                          </kendo-splitter-pane>

                          <kendo-splitter-pane [collapsible]="true">
                            <div class="pane-content">
                              <section class="margin-10">
                                <kendo-grid [data]="selectedRolesGridView"
                                            [navigable]="true"
                                            [filterable]="true"
                                            [groupable]="false"
                                            [reorderable]="true"
                                            [resizable]="false"
                                            [sort]="selectedRolesGridstate.sort"
                                            (sortChange)="selectedRolesGridSortChange($event)"
                                            [pageable]="{ buttonCount: 5, info: true }"
                                            [pageSize]="selectedRolesGridstate.take"
                                            [skip]="selectedRolesGridstate.skip"
                                            [columnMenu]="false"
                                            (pageChange)="selectedRolesGridPageChange($event)"
                                            (dataStateChange)="selectedRolesDataStateChange($event)"
                                            [filter]="selectedRolesGridstate.filter">
                                  <kendo-grid-column field="rolesCode" title="Selected Roles"></kendo-grid-column>
                                  <kendo-grid-command-column [width]="80"
                                                             [headerStyle]="{'background-color': '#d3d3d3', 'border-color': 'rgba(0,0,0,0)'}"
                                                             [footerStyle]="{'border-color': 'rgba(0,0,0,0)'}">
                                    <ng-template kendoGridCellTemplate class="d-super-center" let-dataItem let-rowIndex="rowIndex">
                                      <button class="k-button k-grid-remove-command " (click)="deleteSelectedRoles(rowIndex)">
                                        <span class="k-icon k-i-trash">
                                        </span>
                                      </button>
                                    </ng-template>
                                  </kendo-grid-command-column>
                                  <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
                                    <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                                    <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
                                    <kendo-pager-info></kendo-pager-info>
                                    <kendo-pager-next-buttons></kendo-pager-next-buttons>
                                    <kendo-pager-page-sizes [pageSizes]="[50,75,100]"></kendo-pager-page-sizes>
                                  </ng-template>
                                </kendo-grid>
                              </section>
                            </div>
                          </kendo-splitter-pane>

                        </kendo-splitter>
                      </kendo-splitter-pane>
                    </kendo-splitter>

                  </div>
                </div>

                <div class="row">
                  <div class="col-12 center">
                    <button kendoButton primary="true" class="m-3" (click)="continueNextPanel('roles')">
                      Continue
                    </button>
                  </div>
                </div>
              </ng-template>
            </kendo-panelbar-item>
            <kendo-panelbar-item [expanded]="false">
              <ng-template kendoPanelBarItemTitle>
                <span>Account Activity</span>
                <span class="k-icon k-i-cancel" style="color:red;font-weight:300"
                      *ngIf="!newUserForm.label.isAccountActivityValid && newUserForm.label.isSubmitted"></span>
                <span class="k-icon k-i-check-circle k-i-checkmark-circle"
                      *ngIf="newUserForm.label.isAccountActivityValid && newUserForm.label.isSubmitted"
                      style="color:green;font-weight:600"></span>
              </ng-template>
              <ng-template kendoPanelBarContent>
                <div class="row margin-10">
                  <div class="col-sm-1"></div>
                  <div class="col-sm-10">
                    <div class="row">
                      <div class="col-sm-6">
                        <h6>Actions</h6>
                        <!--isActive-->
                        <div class="form-group">
                          <kendo-switch name="isActive" [(ngModel)]="newUser.isActive" [onLabel]="'Yes'" [offLabel]="'No'">
                          </kendo-switch>
                          <label class="lbl switch-labels">{{newUserForm?.label?.isActive}}</label>
                        </div>
                        <div class="form-group">
                          <kendo-switch name="forcePasswordReset" [(ngModel)]="newUser.forcePasswordReset" [onLabel]="'Yes'" [offLabel]="'No'">
                          </kendo-switch>
                          <label class="lbl switch-labels">{{newUserForm?.label?.forcePasswordReset}}</label>
                        </div>
                        <div class="form-group">
                          <kendo-switch name="forceTermsAndCondition" [(ngModel)]="newUser.forceTermsAndCondition" [onLabel]="'Yes'" [offLabel]="'No'">
                          </kendo-switch>
                          <label class="lbl switch-labels">{{newUserForm?.label?.forceTermsAndCondition}}</label>
                        </div>
                        <div class="form-group">
                          <kendo-switch name="canPlaceOrder " [(ngModel)]="newUser.canPlaceOrder" [onLabel]="'Yes'" [offLabel]="'No'">
                          </kendo-switch>
                          <label class="lbl switch-labels">{{newUserForm?.label?.canPlaceOrder}}</label>
                        </div>
                        <div class="form-group">
                          <kendo-switch name="sendTempPW" [(ngModel)]="newUser.sendTempPW"  [onLabel]="'Yes'" [offLabel]="'No'">
                          </kendo-switch>
                          <label class="lbl switch-labels">{{newUserForm?.label?.sendTempPW}}</label>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div><b>Last Login Date/TimeStamp: </b><p>{{newUser.LastLogin}}</p></div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </kendo-panelbar-item>

          </kendo-panelbar>
          <div class="row" style="text-align:center">
            <div class="col-sm-12">
              <div class="btn-group" role="group">
                <button kendoButton [disabled]="newUserForm.saveInProcess" class=" m-3 btn k-button dialogBtnSize"
                        (click)="closeWorkListUserForm()">
                  Close
                </button> &nbsp;&nbsp;
                <button kendoButton [disabled]="newUserForm.saveInProcess" class=" m-3 btn btn-success dialogBtnSize"
                        (click)="insertUserData('save','workList')">
                  Save <kendo-loader *ngIf="newUserForm.saveInProcess" style="color:blue"></kendo-loader>
                </button>
                <button kendoButton [disabled]="newUserForm.saveInProcess" class=" m-3 btn btn-success dialogBtnSize"
                        (click)="insertUserData('approve','workList')">
                  Approve <kendo-loader *ngIf="newUserForm.saveInProcess" style="color:blue"></kendo-loader>
                </button>
                <!--<button kendoButton [disabled]="newUserForm.saveInProcess" class=" m-3 btn btn-success">-->
                <!--(click)="insertUserData('approve','workList')">-->
                <!--Set Default Password <kendo-loader *ngIf="newUserForm.saveInProcess" style="color:blue"></kendo-loader>
                </button>-->
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </kendo-tabstrip-tab>
  </kendo-tabstrip>
</section>
<kendo-dialog title="{{userAdmin.label.confirmLbl?userAdmin.label.confirmLbl:userAdmin.label.confirmLbl}}" *ngIf="gridItemToRemove" (close)="confirmRemove(false)">
  <p style="margin: 30px; text-align: center;">
    {{userAdmin.label.deleteConfirmLbl?userAdmin.label.deleteConfirmLbl:userAdmin.label.deleteConfirmLbl}}
    <b> : {{ gridItemToRemove.userName }}</b>?
  </p>
  <kendo-dialog-actions>
    <button class='k-button' (click)="confirmRemove(false)">
      {{userAdmin.label.deleteNoLbl?userAdmin.label.deleteNoLbl:userAdmin.label.deleteNoLbl}}
    </button>
    <button class='k-button k-primary' (click)="confirmRemove(true)" primary="true">
      {{userAdmin.label.deleteYesLbl?userAdmin.label.deleteYesLbl:userAdmin.label.deleteYesLbl}}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
